import React from 'react';
import LoginContainer from 'components/consumer/LoginSidebar/login-container';

const SignUpPage = () => (
  <div className="md:w-[28rem] md:mx-auto md:border md:border-solid md:border-gray-light7 md:my-32">
    <LoginContainer initialState={{ showSignUp: true }} variant="login-page" />
  </div>
);

export default SignUpPage;
